import { create } from "../../../common/utils/zustand_state_manager";
import { IComprasService } from "../../../features/compras/data/services/compras_service";
import { ComprasService } from "../../../features/compras/data/services/compras_service_impl";

/**
 * useComprasServices
 */

type State = {
  comprasService: IComprasService,
};

export const useComprasServices = create<State>((set, get) => ({
  comprasService: new ComprasService(),
}));